import { environment } from '@env/environment';

export const maxPageSize = 1000000;

export const placeholderImg =
  environment.wordpressJipImages + 'placeholder.png';

/** Person silhouette, used wherever a missing avatar would leave a blank slot. */
export const defaultAvatarImg =
  environment.wordpressJipImages + 'avatar-square.png';

export const SUGGESTIONS = 'Suggestions';

export const ATTRIBUTES_TO_REMOVE = ['class', 'style'];

export const DAYS_OF_WEEK = 7;

export const DEFAULT_VALUE = 'DefaultValue';

export const NEW_LINE_CODE = '%0D%0A';
